import { ReduxHelper } from "helpers";
import { ISearchByTextResponse } from "models/ResponseModels";

export const prefix = "SEARCH";

const searchByText = ReduxHelper.generateActions<string, ISearchByTextResponse>(`${prefix}/SEARCH_BY_TEXT`);

export { searchByText };
